import React, { useState } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
export const usePaytm = (data) => {
    let paymentDat = data;
    const [paymentBuffer, setPaymentBuffer] = useState(false)

    const makePaytmPayment = () => {
        setPaymentBuffer(true)
        axios.get("/sanctum/csrf-cookie").then((response) => {
            axios.post(`/api/paytm-payment`, paymentDat).then((response) => {
                setPaymentBuffer(false)
                var information = {
                    action: "https://securegw-stage.paytm.in/order/process",
                    params: response.data,
                };
                post(information);
            });
        });


        function isDate(val) {
            // Cross realm comptatible
            return Object.prototype.toString.call(val) === "[object Date]";
        }

        function isObj(val) {
            return typeof val === "object";
        }

        function stringifyValue(val) {
            if (isObj(val) && !isDate(val)) {
                return JSON.stringify(val);
            } else {
                return val;
            }
        }

        function buildForm({ action, params }) {
            const form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", action);

            Object.keys(params).forEach((key) => {
                const input = document.createElement("input");
                input.setAttribute("type", "hidden");
                input.setAttribute("name", key);
                input.setAttribute("value", stringifyValue(params[key]));
                form.appendChild(input);
            });

            return form;
        }

        function post(details) {
            const form = buildForm(details);
            document.body.appendChild(form);
            form.submit();
            form.remove();
        }



    }

    return { makePaytmPayment, paymentBuffer }
}